// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/fss-surveillance-display.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/fss-surveillance-display/fss-surveillance-display.js';

mount([g0]);
